// @flow strict
import type {FlowBuilderState} from 'src/reducers/flow-builder';
import type {AgentSettingsTypes} from 'src/types/flow-builder';
// $FlowFixMe[nonstrict-import]
import type {Dispatch, ThunkAction} from 'src/reducers';
// $FlowFixMe[nonstrict-import]
import * as reduxApiV2 from 'src/utils/redux-api-v2';


export const UPDATE_FLOW_BUILDER = 'flow-builder/update';
export const RESET_FLOW_TEMPLATES = 'flow-builder/reset-templates';
export const UPDATE_AGENT_SETTINGS = 'flow-builder/update-agent-settings';

const options = {
  voices: [
    {label: 'Reva', key: 'reva'},
    {label: 'Mia', key: 'mia'},
    {label: 'Liam', key: 'liam'},
    {label: 'Grace', key: 'grace'},
  ],
  brands: [
    {label: 'Google', key: 'google'},
    {label: 'Amazon', key: 'amazon'},
    {label: 'Microsoft', key: 'microsoft'},
    {label: 'IBM', key: 'ibm'},
    {label: 'Nuance', key: 'nuance'},
  ],
  languages: [
    {label: 'US-EN', key: 'us-en'},
    {label: 'UK-EN', key: 'uk-en'},
    {label: 'FR-FR', key: 'fr-fr'},
    {label: 'DE-DE', key: 'de-de'},
    {label: 'ES-ES', key: 'es-es'},
    {label: 'IT-IT', key: 'it-it'},
  ],
  roles: [
    {label: 'Virtual Recruiter', key: 'virtual_recruiter'},
    {label: 'Virtual Assistant', key: 'virtual_assistant'},
    {label: 'Virtual Sales Assistant', key: 'virtual_sales_assistant'},
    {label: 'Virtual Customer Service', key: 'virtual_customer_service'},
  ],
  industries: [
    {label: 'Healthcare', key: 'healthcare'},
    {label: 'Finance', key: 'finance'},
    {label: 'Retail', key: 'retail'},
    {label: 'Education', key: 'education'},
  ],
  jobSpecialities: [
    {label: 'Nurse', key: 'nurse'},
    {label: 'Doctor', key: 'doctor'},
    {label: 'Accountant', key: 'accountant'},
    {label: 'Teacher', key: 'teacher'},
    {label: 'Sales', key: 'sales'},
    {label: 'Marketing', key: 'marketing'},
    {label: 'Engineer', key: 'engineer'},
    {label: 'Developer', key: 'developer'},
    {label: 'Designer', key: 'designer'},
    {label: 'Data Scientist', key: 'data_scientist'},
    {label: 'HR', key: 'hr'},
    {label: 'Project Manager', key: 'project_manager'},
    {label: 'Product Manager', key: 'product_manager'},
    {label: 'Business Analyst', key: 'business_analyst'},
    {label: 'Customer Support', key: 'customer_support'},
    {label: 'Marketing Manager', key: 'marketing_manager'},
    {label: 'Sales Manager', key: 'sales_manager'},
    {label: 'Operations Manager', key: 'operations_manager'},
    {label: 'IT Manager', key: 'it_manager'},
    {label: 'Network Engineer', key: 'network_engineer'},
  ],
};

const defaultAgentSettings = {
  voiceBot: {
    selectedVoice: 'reva',
    selectedBrand: 'google',
    selectedLanguage: 'us-en',
    selectedRole: 'virtual_recruiter',
    responsiveness: 3,
    voiceSpeed: 5,
    speechNormalization: false,
  },
  voicemail: {
    voicemailDetection: false,
    voicemailAction: 'Leave a message',
    voicemailDuration: 30,
    message: '',
  },
  additionalContext: {
    selectedIndustry: 'healthcare',
    jobSpecialities: [],
  },
};

const agentSettings = {
  voiceBot: {
    selectedVoice: 'mia',
    selectedBrand: 'amazon',
    selectedLanguage: 'us-en',
    selectedRole: 'virtual_recruiter',
    responsiveness: 3,
    voiceSpeed: 5,
    speechNormalization: false,
  },
  voicemail: {
    voicemailDetection: false,
    voicemailAction: 'Leave a message',
    voicemailDuration: 30,
    message: '',
  },
  additionalContext: {
    selectedIndustry: 'healthcare',
    jobSpecialities: [],
  },
};

const workstream = {
  id: 3629,
  initial_node: '1',
  nodes: {
    '1': {
      id: '1',
      label: 'Initiate the candidate conversation',
      capabilities: [
        {
          node_id: '1',
          capability_type: 'message',
          id: 'message_1',
          actions: [
            {
              action_type: 'show_message',
              action_id: 'show_message_1',
              params: {
                message_text: 'Hello <Full Name>, you are <Age> years old.',
              },
            },
          ],
        },
      ],
      next_nodes: [
        {
          condition: {
            blocks: [
              {
                rules: [
                  {
                    id: 1,
                    conditions: [],
                  },
                ],
              },
            ],
          },
          next_node: '2',
        },
      ],
    },
    '2': {
      id: '2',
      label:
        'Targeted questions designed to evaluate the candidate\'s background',
      capabilities: [
        {
          node_id: '2',
          capability_type: 'question',
          id: 'question_1',
          actions: [
            {
              action_type: 'ask_question',
              action_id: 'ask_question_1',
              params: {question_id: 456},
              subactions: [
                {
                  action_type: 'fwb_trigger',
                  action_id: 'fwb_1',
                  fieldwriteback_map: {'Full Name': 'user_full_name'},
                },
              ],
            },
            {
              action_type: 'ask_question',
              action_id: 'ask_question_2',
              params: {prompt_text: 'What is your age?'},
              subactions: [
                {
                  action_type: 'fwb_trigger',
                  action_id: 'fwb_2',
                  fieldwriteback_map: {Age: 'user_age'},
                },
              ],
            },
          ],
        },
      ],
      next_nodes: [
        {
          condition: {
            blocks: [
              {
                rules: [
                  {
                    id: 1,
                    conditions: [
                      {
                        field:
                          '{{$.entity_group_fetch__bh_job_submission.response.relatedEntities.candidate.entity.data.phone}}',
                        value: null,
                        operator: 'is_not_empty_and_not_null',
                      },
                    ],
                  },
                ],
              },
            ],
          },
          next_node: '3',
        },
        {
          condition: {
            blocks: [
              {
                rules: [
                  {
                    id: 1,
                    conditions: [
                      {
                        field:
                          '{{$.entity_group_fetch__bh_job_submission.response.relatedEntities.candidate.entity.data.phone}}',
                        value: null,
                        operator: 'is_empty_or_null',
                      },
                    ],
                  },
                ],
              },
            ],
          },
          next_node: '4',
        },
      ],
    },
    '3': {
      id: '3',
      label: 'End conversation with candidate',
      next_nodes: [],
      capabilities: [
        {
          node_id: '3',
          capability_type: 'message',
          id: 'message_1',
          actions: [
            {
              action_type: 'show_message',
              action_id: 'show_message_1',
              params: {
                message_text: 'Hello <Full Name>, you are <Age> years old.',
              },
            },
          ],
        },
      ],
    },
    '4': {
      id: '4',
      label: 'End conversation with candidate',
      next_nodes: [],
      capabilities: [
        {
          node_id: '4',
          capability_type: 'message',
          id: 'message_1',
          actions: [
            {
              action_type: 'show_message',
              action_id: 'show_message_1',
              params: {
                message_text: 'Hello <Full Name>, you are <Age> years old.',
              },
            },
          ],
        },
      ],
    },
  },
};

type UpdateFlowBuilderPayload = $Shape<FlowBuilderState>;

type UpdateFlowBuilderAction = {
  type: 'flow-builder/update',
  payload: UpdateFlowBuilderPayload,
};

type ResetFlowTemplatesAction = {
  type: 'flow-builder/reset-templates',
};

type UpdateAgentSettingsAction = {
  type: 'flow-builder/update-agent-settings',
  payload: UpdateFlowBuilderPayload,
};

export type FlowBuilderActions =
  | UpdateFlowBuilderAction
  | ResetFlowTemplatesAction
  | UpdateAgentSettingsAction;

export const updateFlowBuilder = (
  payload: UpdateFlowBuilderPayload,
): UpdateFlowBuilderAction => ({
  type: UPDATE_FLOW_BUILDER,
  payload,
});

export const resetFlowTemplates = (): ResetFlowTemplatesAction => ({
  type: RESET_FLOW_TEMPLATES,
});

export const updateAgentSettings = (
  payload: UpdateFlowBuilderPayload,
): UpdateAgentSettingsAction => ({
  type: UPDATE_AGENT_SETTINGS,
  payload,
});

export const getFlowTemplates: () => ThunkAction<UpdateFlowBuilderPayload> =
  () => (dispatch: Dispatch) => {
    /*
    return dispatch(reduxApiV2.get(`flow-builder/templates`))
      .then((templates: FlowBuilderState['templates']) => {
        return dispatch(updateFlowBuilder({templates}));
      })
      .catch((error) => {
        throw error;
      });
      */

    // TODO(darsh): mock api
    const templates = [
      {
        id: '1',
        title: 'Interview Scheduling',
        description:
          'Arrange interview times with candidates to streamline hiring.',
        tags: ['Candidates', 'Interviews'],
      },
      {
        id: '2',
        title: 'Candidate Screening',
        description: 'Quickly pre-screen candidates accross industries.',
        tags: ['Candidates', 'Screening'],
      },
      {
        id: '3',
        title: 'Onboarding Preparation',
        description:
          'Prepare new hires for onboarding by discussing start dates.',
        tags: ['Candidates', 'Engagement'],
      },
      {
        id: '4',
        title: 'Skill Assessment',
        description:
          'Assess specific technical skills for precision-based roles.',
        tags: ['Candidates', 'Verification'],
      },
      {
        id: '5',
        title: 'Interview Feedback',
        description:
          'Collect feedback from interviewers after candidate interviews.',
        tags: ['Candidates', 'Interviews'],
      },
      {
        id: '6',
        title: 'Candidate Engagement',
        description:
          'Engage with candidates to keep them informed and interested.',
        tags: ['Candidates', 'Engagement'],
      },
      {
        id: '7',
        title: 'Background Verification',
        description:
          'Verify candidate backgrounds and credentials for security purposes.',
        tags: ['Candidates', 'Verification'],
      },
      {
        id: '8',
        title: 'Interview Reminders',
        description:
          'Send reminders to candidates about upcoming interviews to reduce no-shows.',
        tags: ['Candidates', 'Interviews'],
      },
    ];

    const result = new Promise((res) => {
      setTimeout(() => res(templates), 500);
    });
    return result
      .then((t: FlowBuilderState['templates']) =>
        dispatch(updateFlowBuilder({templates: t})),
      )
      .catch((e) => e);
  };

export const getTemplateWorkstream: (
  templateId: string,
) => ThunkAction<mixed> = (templateId: string) => (dispatch: Dispatch) => {
  /*
    dispatch(updateFlowBuilder({isWorkstreamLoading: true}));
    return dispatch(reduxApiV2.get(`flow-builder/${templateId}/workstream`))
      .then((workstream: FlowBuilderState['workstream']) => {
        return dispatch(updateFlowBuilder({workstream}));
      })
      .catch((error) => {
        throw error;
      })
      .finally(() => {
        dispatch(updateFlowBuilder({isWorkstreamLoading: false}));
      });
      */

  const result = new Promise((res) => {
    setTimeout(() => res(workstream), 500);
  });

  dispatch(updateFlowBuilder({isWorkstreamLoading: true}));
  return result
    .then((ws: FlowBuilderState['workstream']) =>
      dispatch(updateFlowBuilder({workstream: ws})),
    )
    .catch((e) => e)
    .finally(() => dispatch(updateFlowBuilder({isWorkstreamLoading: false})));
};

export const getWorkstream: (flowId: string) => ThunkAction<mixed> =
  (flowId: string) => (dispatch: Dispatch) => {
    /*
    dispatch(updateFlowBuilder({isWorkstreamLoading: true}));
    return dispatch(reduxApiV2.get(`flow-builder/${flowId}/workstream`))
      .then((workstream: FlowBuilderState['workstream']) => {
        return dispatch(updateFlowBuilder({workstream}));
      })
      .catch((error) => {
        throw error;
      })
      .finally(() => {
        dispatch(updateFlowBuilder({isWorkstreamLoading: false}));
      });
      */

    const result = new Promise((res) => {
      setTimeout(() => res(workstream), 500);
    });

    dispatch(updateFlowBuilder({isWorkstreamLoading: true}));
    return result
      .then((ws: FlowBuilderState['workstream']) =>
        dispatch(updateFlowBuilder({workstream: ws})),
      )
      .catch((e) => e)
      .finally(() => dispatch(updateFlowBuilder({isWorkstreamLoading: false})));
  };

export const createFlowFromTemplate: (
  templateId: string,
) => ThunkAction<mixed> = (templateId: string) => {
  // return reduxApiV2.post(`flow-builder/create-flow`, {templateId});

  const result = () =>
    new Promise((res) => {
      setTimeout(() => res('mock-flow-id'), 500);
    });

  return result;
};

export const getAgentSettingsOptions: () => ThunkAction<mixed> =
  () => (dispatch: Dispatch) => {
    /*
    return dispatch(reduxApiV2.get(`flow-builder/agent-settings/options`))
      .then((res) => {
        return res
      })
      .catch((error) => {
        throw error;
      });
      */

    // TODO(sahil): mock api

    const result = new Promise((res) => {
      setTimeout(() => res(options), 500);
    });
    return result;
  };

export const getAgentSettings: (flowId: string) => ThunkAction<void> =
  () => (dispatch: Dispatch) => {
    /*
    return dispatch(reduxApiV2.get(`flow-builder/agent-settings/id`))
      .then((res) => {
        return res
      })
      .catch((error) => {
        throw error;
      });
      */

    // TODO(sahil): mock api
    // in case of new flow , we would use default values as backend would not return any data
    const result = new Promise<FlowBuilderState['agentSettings']>((res) => {
      setTimeout(() => res(agentSettings ?? defaultAgentSettings), 500);
    });
    return result
      .then((t: FlowBuilderState['agentSettings']) => {
        dispatch(updateFlowBuilder({agentSettings: t}));
      })
      .catch((e) => e);
  };

export const saveAgentSettings: (
  newSettings: AgentSettingsTypes,
) => Promise<mixed> = () => {
  /*
    return dispatch(reduxApiV2.post(`flow-builder/agent-settings/save`, payload))
      .then((res) => {
        return res
      })
      .catch((error) => {
        throw error;
      });
      */

  // TODO(sahil): mock api
  const result = new Promise((res) => {
    setTimeout(() => res('success'), 500);
  });
  return result;
};
